import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { action, entries, makeObservable, observable, override } from 'mobx';
import fuzzysort from 'fuzzysort';
import FieldFilter from "./FieldFilter.js";
export class SearchFilter extends FieldFilter {
  static createComparator(fieldName) {
    return (results, store) => results.sort((a, b) => {
      var _a$fields$fieldName$s, _a$fields$fieldName, _b$fields$fieldName$s, _b$fields$fieldName;
      var aScore = (_a$fields$fieldName$s = (_a$fields$fieldName = a.fields[fieldName]) === null || _a$fields$fieldName === void 0 ? void 0 : _a$fields$fieldName.score) !== null && _a$fields$fieldName$s !== void 0 ? _a$fields$fieldName$s : 0;
      var bScore = (_b$fields$fieldName$s = (_b$fields$fieldName = b.fields[fieldName]) === null || _b$fields$fieldName === void 0 ? void 0 : _b$fields$fieldName.score) !== null && _b$fields$fieldName$s !== void 0 ? _b$fields$fieldName$s : 0;
      return aScore == bScore ? 0 : aScore < bScore ? -1 : 1;
    });
  }
  constructor(fieldName) {
    var _this$predicate;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super(fieldName, _objectSpread({
      matchOnEmpty: true,
      initialState: null
    }, params));
    _defineProperty(this, "predicate", void 0);
    this.predicate = (_this$predicate = this.predicate) !== null && _this$predicate !== void 0 ? _this$predicate : (result, query) => {
      // console.log('predicate')
      var matches = fuzzysort.go(query, [{
        locationName: result.locationName
      }], {
        key: 'locationName'
      });
      if (matches.length) {
        result.fields[this.fieldName] = {
          score: matches[0].score,
          match: fuzzysort.highlight(matches[0], p => p)
        };
        // console.log(query, result.fields[this.fieldName]);
        return true;
      } else {
        return false;
      }
    };
    makeObservable(this, {
      predicate: observable,
      setState: override,
      updateResults: action
    });
  }
  init(store) {
    super.init(store);
    store.hooks.afterResultsUpdate.add(() => this.updateResults());
  }
  updateResults() {
    if (this.state && !this.disabled) {
      for (var [id, _result] of entries(this.store.results)) {
        var match = this.predicate(_result, this.state);
        if (match && !_result.fields[this.fieldName]) {
          _result.fields[this.fieldName] = {
            score: 0,
            match: null
          };
        } else if (!match) {
          //&& result.fields[this.fieldName]) {
          _result.fields[this.fieldName] = null;
        } // it's already been updated
      }
    } else {
      for (var [_id, _result2] of entries(this.store.results)) {
        _result2.fields[this.fieldName] = null;
      }
    }
  }
  setState(nValue) {
    super.setState(nValue);
    this.updateResults();
  }
  exposeParams() {
    return _objectSpread(_objectSpread({}, super.exposeParams()), {}, {
      predicate: this.predicate
    });
  }
  createSnapshot() {
    var deproxyify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return _objectSpread(_objectSpread({}, super.createSnapshot(deproxyify)), {}, {
      predicate: this.predicate
    });
  }
  applySnapshot(snapshot) {
    super.applySnapshot(snapshot);
    this.predicate = snapshot.predicate;
  }
  get isEmpty() {
    return this.matchOnEmpty ? this.state === null || this.state === '' : false;
  }
  test(location) {
    return this.disabled || this.matchOnEmpty && this.isEmpty || !this.isEmpty && location.fields[this.fieldName] !== null;
  }
}
export default SearchFilter;
//# sourceMappingURL=SearchFilter.js.map